export const displayTimeRemaining = (secondsLeft: number): string => {
  const minutesLeft = Math.floor(secondsLeft / 60)
  let secondsInMinuteLeft: number | string = secondsLeft % 60
  if (secondsInMinuteLeft < 10) secondsInMinuteLeft = `0${secondsInMinuteLeft}`

  return `${minutesLeft}:${secondsInMinuteLeft}`
}

export const filterMapObject = <K, V>(
  map: Map<K, V>,
  predicate: (entry: [K, V]) => boolean
): Map<K, V> => {
  const clone = new Map(map)

  for (const entry of clone.entries()) {
    if (!predicate(entry)) {
      clone.delete(entry[0])
    }
  }

  return clone
}

export function assertNotNull<T>(
  value: T | null,
  message?: string
): asserts value is T {
  if (value === null) {
    throw new Error(message ?? 'Expected value to be non-null')
  }
}
